export const playVideo = (event) => {
  const element = event.target;
  const blanket = element.closest(".simulation").previousElementSibling;
  if (!blanket) return;
  blanket.classList.remove("d-none");
  blanket.classList.add("d-block");
  const video = blanket.querySelector("video");
  video?.play();
};

export const pauseVideo = (event) => {
  const element = event.target.closest(".simulation-blanket");
  if (!element) return;
  element.classList.remove("d-block");
  element.classList.add("d-none");
  const video = element.querySelector("video");
  video?.pause();
};

export const stopProps = (event) => {
  event.stopPropagation();
};
